// Generated by scripts/styles/generate-public-styles.mjs. Do not edit.
export const publicStylesHref = "/styles/public.89924110e26c2745.css"
export const articleStylesHref = "/styles/article-critical.d62faaf8d25764fd.css"
export const productStylesHref = "/styles/product-critical.c745768123d7ef5e.css"
export const compareStylesHref = "/styles/compare-critical.b2db0173bff32e6a.css"
export const hubStylesHref = "/styles/hub-critical.3cc3dc913c4a0756.css"
export const brandStylesHref = "/styles/brand-critical.6ef0b6f0d75210b8.css"
